import stylex from '@stylexjs/stylex';
import { palette } from '@shared/tokens/palette.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';

export const styles = stylex.create({
  button: {
    fontFamily: fonts.din2014Regular,
    color: palette.greyWhite,
    fontSize: '18px',
  },
});
